import { useNote } from './useNote';
import { useCallback } from 'react';
import { useAnyContextNoteId } from './useAnyContextNoteId';
export var useGetNoteLastActionDate = function () {
    var noteId = useAnyContextNoteId();
    var data = useNote(noteId).data;
    var getNoteLastActionDate = useCallback(function () {
        var _a;
        return (_a = data === null || data === void 0 ? void 0 : data.signedAt) !== null && _a !== void 0 ? _a : data === null || data === void 0 ? void 0 : data.updatedAt;
    }, [data]);
    return getNoteLastActionDate;
};
